'use client'

import { useEffect } from 'react'

import { getPlatform } from '~/components/PWAInstallBanner'

export function MobileManifest() {
  useEffect(() => {
    const platform = getPlatform()
    if (platform === 'ios' || platform === 'android') {
      const link = document.createElement('link')
      link.rel = 'manifest'
      link.href = '/manifest.json'
      document.head.appendChild(link)
      return () => {
        document.head.removeChild(link)
      }
    }
  }, [])
  return null
}
